import React from 'react';
import { Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { datasetUrl } from '@/constants/urls';

const DatasetCell = ({ dataset }) => (
  <Table.Cell>
    {dataset?.code && (
    <Link to={datasetUrl(dataset)} title={dataset?.catalogue?.title}>
      {dataset?.catalogue?.title}
    </Link>
    )}
  </Table.Cell>
);

export default DatasetCell;
